import { useState } from 'react';
import { Col, Row, Button } from 'reactstrap';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import PromotionTable from './PromotionTable';
import { useNavigate, useParams } from 'react-router-dom';
import DynamicFilter from './DynamicFilter';

const promotionStatusOptions = [
  { value: 'published', label: 'Published' },
  { value: 'draft', label: 'Draft' },
  { value: 'paused', label: 'Paused' },
  { value: 'expired', label: 'Expired' },
];

const promotionTagsOptions = [
  { value: 'Points', label: 'Points' },
  { value: 'Transactional', label: 'Transactional' },
];
const effectTypeOptions = [
  { value: 'Transactional', label: 'Transactional' },
  { value: 'Rewards', label: 'Rewards' },
  { value: 'Messages', label: 'Messages' },
];
const triggerTypeOptions = [
  { value: 'coupon', label: 'By Applying a Coupon' },
  { value: 'autoapply', label: 'Auto Applied at Cart' },
  { value: 'event', label: 'On Event' },
  { value: 'scheduled', label: 'Scheduled' },
];

const sortByOptions = [
  {
    label: 'Default',
    value: null,
  },
  {
    label: 'Start Date (asc)',
    value: {
      key: 'launcher.startDate',
      order: 'asc',
    },
  },
  {
    label: 'Start Date (desc)',
    value: {
      key: 'launcher.startDate',
      order: 'desc',
    },
  },
  {
    label: 'End Date (asc)',
    value: {
      key: 'launcher.endDate',
      order: 'asc',
    },
  },
  {
    label: 'End Date (desc)',
    value: {
      key: 'launcher.endDate',
      order: 'desc',
    },
  },
  {
    label: 'Creation Date (asc)',
    value: {
      key: 'createdAt',
      order: 'asc',
    },
  },
  {
    label: 'Creation Date (desc)',
    value: {
      key: 'createdAt',
      order: 'desc',
    },
  },
];

const filterOptions = [
  {
    label: 'Status',
    filterColumn: 'status',
    options: promotionStatusOptions,
  },
  {
    label: 'Trigger Type',
    filterColumn: 'triggerType',
    options: triggerTypeOptions,
  },
  {
    label: 'Effect Type',
    filterColumn: 'productEligibility.effectTypeInvolved',
    options: effectTypeOptions,
  },
  {
    label: 'Tags',
    filterColumn: 'basicSettings.tags',
    options: promotionTagsOptions,
  },
  {
    label: 'Country',
    filterColumn: 'basicSettings.country',
    options: [],
  },
  {
    label: 'Brands',
    filterColumn: 'basicSettings.brands',
    options: [],
  },
  {
    label: 'Stores',
    filterColumn: 'basicSettings.stores',
    options: [],
  },
  {
    label: 'Date',
    type: 'dateRange',
    filterColumn: 'launcher.startDate',
  },
  {
    label: 'Supplier participation',
    type: 'boolean',
    filterColumn: 'basicSettings.meta.allowSupplierParticipation',
    options: [],
  },
  {
    label: 'Bank Offer',
    type: 'boolean',
    isCustomField: true,
    filterColumn: 'messages.isBankOffer',
    options: [],
  },
  ,
];

const Promotion = () => {
  const navigate = useNavigate();
  const { campaignTypeId } = useParams();
  document.title = 'Promotions';

  const [isLoading, setIsLoading] = useState(false);
  const [selectedSortBy, setSelectedSortBy] = useState(null);
  const [selectedFillers, setSelectedFilters] = useState(null);

  return (
    <div className="page-content px-4 pb-4">
      <Row>
        <Col md={12} className="m-auto">
          <BreadCrumb titleInActive={'Admin'} titleActive="Promotions" />

          <div
            style={{ backdropFilter: ' blur(4px)' }}
            className="position-sticky top-0 z-1 d-flex justify-content-between align-items-center py-4"
          >
            <h4 className="mb-0">Promotions</h4>
            <Button
              size="sm"
              color="info"
              onClick={() => {
                navigate(`/promotions/${campaignTypeId}/detail/new`);
              }}
              className="d-flex align-items-center gap-1"
            >
              <i className="bx bx-plus"></i> Create New Promotion
            </Button>
          </div>

          <DynamicFilter
            filters={filterOptions}
            sortByOptions={sortByOptions}
            onFilterChange={(data) => {
              console.log('Selected Filters:', data);
              setSelectedFilters(data?.filters);
              setSelectedSortBy(data?.sortBy);
            }}
          />

          <PromotionTable
            selectedSortBy={selectedSortBy}
            selectedFillers={selectedFillers}
          />
        </Col>
      </Row>
    </div>
  );
};

export default Promotion;
